import { useEffect, useState } from "react";
import { FaLightbulb, FaGripLines, FaChevronDown, FaChevronRight } from "react-icons/fa";
import magic from "./magic";
import { setLightTimer, readLightingConfig } from "./controllers/lightsParameters";
import LayerControl from "./components/LayerControl";
import LightsMoods from "./components/LightsMoods";
import "./LightsPanel.css";

function LightsPanel({ visible = true }) {
	const [white, setWhite] = useState([0, 0, 0]);
	const [timer, setTimer] = useState(null);
	const [button, setButton] = useState(0);
	const [ledBar, setLedBar] = useState(0);
	const [layers, setLayers] = useState([]);
	const [layersCollapsed, setLayersCollapsed] = useState(true);

	useEffect(() => {
		const onLights = (lights) => {
			setWhite(lights.white);
			setTimer(lights.timer);
			setButton(lights.button);
			setLedBar(lights.ledBar);
			setLayers(lights.layers || []);
		};
		magic.bleEventDispatcher.on("lights", onLights);
		return () => {
			magic.bleEventDispatcher.removeListener("lights", onLights);
		};
	}, []);

    useEffect(() => {
      let current=true;
      readLightingConfig(()=>current).catch(e=>magic.bleEventDispatcher.emit('command-error',e.message));
      return ()=>{current=false;};
    },[]);
	const lightsOn = timer > 0;
	const ledBarOn = ledBar > 0;

	const formatTimer = (seconds) => {
		if (!seconds || seconds <= 0) return 'Off';
		const hrs = Math.floor(seconds / 3600);
		const mins = Math.floor((seconds % 3600) / 60);
		if (hrs > 0) return `${hrs}h ${mins}m`;
		return `${mins}m`;
	};

	if (!visible) return null;

	return (
		<div className="lights-panel">
			{/* Main Controls */}
			<div className="lights-controls-grid">
				<button
					className={`lights-control-tile ${lightsOn ? 'active' : ''}`}
					onClick={() => (lightsOn ? turnLightOff() : turnLightOn())}
				>
					<FaLightbulb size={36} color={lightsOn ? '#3a6' : '#666'} />
					<span className="lights-control-label">Main Lights</span>
					<span className="lights-control-status">{formatTimer(timer)}</span>
				</button>

				<button
					className={`lights-control-tile ${ledBarOn ? 'active' : ''}`}
					onClick={() => (ledBarOn ? turnBarOff() : turnBarOn())}
				>
					<FaGripLines size={36} color={ledBarOn ? '#3a6' : '#666'} />
					<span className="lights-control-label">LED Bar</span>
					<span className="lights-control-status">{ledBarOn ? 'On' : 'Off'}</span>
				</button>
			</div>



			{/* Moods */}
			<LightsMoods layers={layers} />

			{/* Layers Accordion */}
			<div className="lights-card">
				<button
					className="lights-accordion-header"
					onClick={() => setLayersCollapsed(!layersCollapsed)}
				>
					<span>Layers</span>
					{layersCollapsed ? <FaChevronRight size={14} /> : <FaChevronDown size={14} />}
				</button>
				{!layersCollapsed && (
					<div className="lights-layers-content">
						{layers.map((layer, index) => (
							<LayerControl key={index} layer={layer} index={index} />
						))}
					</div>
				)}
			</div>

			{/* Status Footer */}
			<div className="lights-footer">
				<span>White: {white[0]},{white[1]},{white[2]}</span>
				<span>Button: {button}</span>
			</div>
		</div>
	);
}

async function turnLightOn(){try{await setLightTimer(3600000);}catch(e){console.error(e);}}
async function turnLightOff(){try{await setLightTimer(0);}catch(e){console.error(e);}}
async function turnBarOn(){try{await setLightTimer(3600000,true);}catch(e){console.error(e);}}
async function turnBarOff(){try{await setLightTimer(0,true);}catch(e){console.error(e);}}
export default LightsPanel;
